"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.save = exports.remove = exports.purge = exports.load = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _cookies = require("./cookies");

exports.Cookie = _cookies.Cookie;
exports.necessary = _cookies.necessary;
exports.analytics = _cookies.analytics;
exports.marketing = _cookies.marketing;

var load = function load(key) {
  var _cookie$get;

  return (_cookie$get = _jsCookie.default.get(key)) !== null && _cookie$get !== void 0 ? _cookie$get : null;
};

exports.load = load;

var save = function save(key, value, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var options = (0, _cookies.getOptions)(key, opts);

  if (key in _cookies.necessary) {
    // For now the /set API endpoint only accepts AGREED and SETTINGS
    // and no options are passed.
    if (key === _cookies.Cookie.AGREED || key === _cookies.Cookie.SETTINGS) {
      fetch("/api/cookies/set/?cookie=" + key + "&value=" + value).then(function (res) {
        if (!res.ok) {
          _jsCookie.default.set(key, value, options);
        }
      }).catch(function () {
        _jsCookie.default.set(key, value, options);
      });
      return;
    }

    _jsCookie.default.set(key, value, options);

    return;
  }

  var rawSettings = load(_cookies.Cookie.SETTINGS);

  if (rawSettings === null) {
    return;
  }

  var settings = JSON.parse(rawSettings);

  if ((0, _cookies.shouldSetCookie)(key, settings)) {
    _jsCookie.default.set(key, value, options);
  }
};

exports.save = save;

var remove = function remove(key, opts) {
  if (opts === void 0) {
    opts = {};
  }

  _jsCookie.default.remove(key, opts); // the default domain for many 3rd party services:


  _jsCookie.default.remove(key, (0, _extends2.default)({}, opts, {
    domain: ".kiwi.com"
  }));
};

exports.remove = remove;

var purge = function purge(settings) {
  if (!settings.analytics && !settings.marketing) {
    /**
     * This request performs a side-effect through the set-cookie headers
     * it receives in the response.
     * In the future, we could consider adding logic to verify that the
     * set-cookie headers we're expecting were received, and run the
     * JSCookie based logic only in case we did not get all the expected
     * set-cookie headers or the API call failed.
     */
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetch("/api/cookies/remove/?categories=analytics,marketing");
    Object.keys((0, _extends2.default)({}, _cookies.analytics, _cookies.marketing)).forEach(function (key) {
      remove(key);
    });
    return;
  }

  if (!settings.analytics) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetch("/api/cookies/remove/?categories=analytics");
    Object.keys(_cookies.analytics).forEach(function (key) {
      remove(key);
    });
    return;
  }

  if (!settings.marketing) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetch("/api/cookies/remove/?categories=marketing");
    Object.keys(_cookies.marketing).forEach(function (key) {
      remove(key);
    });
  }
};

exports.purge = purge;